import { render, staticRenderFns } from "./ManagerDetailsScreen.vue?vue&type=template&id=64646147&scoped=true&"
import script from "./ManagerDetailsScreen.vue?vue&type=script&lang=js&"
export * from "./ManagerDetailsScreen.vue?vue&type=script&lang=js&"
import style0 from "./ManagerDetailsScreen.vue?vue&type=style&index=0&id=64646147&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64646147",
  null
  
)

export default component.exports